<template>
  <header class="sitenav" :class="{ sticky: isSticky }">
    <div class="">
      <div class="row">
        <div class="col-12 z100">
          <b-navbar toggleable="" type="light" class="">
            <b-navbar-brand to="/" class="">
              <img
                class="img-fluid logo-center"
                :src="logoSrc"
                alt="Domino's Pizza"
              />
            </b-navbar-brand>

            <img 
  src="../assets/imgs/dominos/haed-interior.png" 
  alt="Domino's Pizza"
  class="menu-center-img"
/>

            <b-navbar-toggle
            v-if="
                    userProfile != undefined && userProfile.email != undefined
                  "
              class="ml-auto"
              target="nav-collapse"
            ></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto pb-4 navbarint">

                <div class="w-100 text-center">
<img
                class="logomenucentral py-5"
                :src="logoSrc"
                width="70"
                alt="Domino's Pizza"
              />

                </div>
              


                <div class="col-12 text-center pt-5 mt-5 d-lg-none">
                  <p class="fXG blanco bold">¿Qué deseas hacer?</p>
                </div>
                <!-- <b-nav-item
                  class="fGpp btnrojo text-center pt-4  cerrarsesion"
                  href="/"
                  v-if="
                    userProfile == undefined || userProfile.email == undefined
                  "
                >
                  Inicio
                </b-nav-item> -->
                <!-- <b-nav-item
                  class="fGp btnrojo text-center pt-4  cerrarsesion"
                  href="#"
                  target="_blank"
                  v-if="
                    userProfile == undefined || userProfile.email == undefined
                  "
                >
                  Términos y Condiciones
                </b-nav-item> -->

                <!-- <b-nav-item
                  class="fGp btnrojo text-left pt-4  cerrarsesion"
                  to="/"
                  v-if="
                    userProfile != undefined && userProfile.email != undefined
                  "
                >
                  <img
                    src="../assets/imgs/dominos/icono-registrar-ticket.png"
                    alt="Registrar un ticket"
                    class="menu-icon"
                    
                  />
                  <span class="menu-text fG">Registrar un ticket</span>
                </b-nav-item> -->
                <b-nav-item
                  class="fGp btnrojo text-left pt-4  cerrarsesion"
                  to="/mis-participaciones"
                  v-if="
                    userProfile != undefined && userProfile.email != undefined
                  "
                >
                  <img
                    src="../assets/imgs/dominos/icono-ver-mis-puntos.png"
                    alt="Ver mis puntos acumulados"
                    class="menu-icon"
                  />
                  <span class="menu-text fG">Ver mis puntos acumulados</span>
                </b-nav-item>

                <b-nav-item
                  class="fGp btnrojo text-left pt-4  cerrarsesion"
                  to="/ganadores"
                  v-if="
                    userProfile != undefined && userProfile.email != undefined
                  "
                >
                 <img
                    src="../assets/imgs/dominos/icono-consultar-ganadores.png"
                    alt="Consultar ganadores"
                    class="menu-icon"
                  />
                  <span class="menu-text fG">Consultar ganadores</span>
                </b-nav-item>

               

                <b-nav-item
                  class="fGp btnrojo text-left pt-4  cerrarsesion"
                  @click="logout()"
                  v-if="
                    userProfile != undefined && userProfile.email != undefined
                  "
                >
                  <img
                src="../assets/imgs/dominos/icono-cerrar-sesion.png"
                alt="Cerrar sesión"
                class="menu-icon"
              />
              <span class="menu-text fG">Cerrar sesión</span>
                </b-nav-item>

                 <b-nav-item
                  class="fGp btnrojo text-left pt-4  cerrarsesion"
                  href="/tyc.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  v-if="
                    userProfile != undefined && userProfile.email != undefined
                  "
                >
                 <img
                    src="../assets/imgs/dominos/icono-terminos-y-condiciones.png"
                    alt="Ver Términos y Condiciones"
                    class="menu-icon"
                  />
                  <span class="menu-text fG">Ver Términos y Condiciones</span>
                </b-nav-item>

               
              </b-navbar-nav>
            </b-collapse>
          </b-navbar>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import * as fb from "../firebase";
import { mapState } from "vuex";
import logoPromo from "../assets/imgs/dominos/dominos-logo-interior.png";

export default {
  data() {
    return {
      uid: null,
      isSticky: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "posts"]),
    logoSrc() {
      return logoPromo;
    },
  },
  mounted() {
    // Detectar el scroll
    window.addEventListener("scroll", this.handleScroll);

    try {
      this.uid = fb.auth.currentUser.uid;
    } catch (e) {
      // Ignorar error si no hay usuario autenticado
    }
  },
  beforeDestroy() {
    // Limpieza del evento
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    handleScroll() {
      this.isSticky = window.scrollY > 5;
    },
  },
};
</script>
